export enum EnergeticCertificateLetter {
  A_PLUS = "A+",
  A = "A",
  A_MINUS = "A-",
  B_PLUS = "B+",
  B = "B",
  B_MINUS = "B-",
  C_PLUS = "C+",
  C = "C",
  C_MINUS = "C-",
  D_PLUS = "D+",
  D = "D",
  D_MINUS = "D-",
  E_PLUS = "E+",
  E = "E",
  E_MINUS = "E-",
  F_PLUS = "F+",
  F = "F",
  F_MINUS = "F-",
  G_PLUS = "G+",
  G = "G",
  G_MINUS = "G-",
  ISENTO = "ISENTO",
}

// Mapping from API format to display format
const API_TO_DISPLAY_MAP: Record<string, EnergeticCertificateLetter> = {
  "A_PLUS": EnergeticCertificateLetter.A_PLUS,
  "A": EnergeticCertificateLetter.A,
  "A_MINUS": EnergeticCertificateLetter.A_MINUS,
  "B_PLUS": EnergeticCertificateLetter.B_PLUS,
  "B": EnergeticCertificateLetter.B,
  "B_MINUS": EnergeticCertificateLetter.B_MINUS,
  "C_PLUS": EnergeticCertificateLetter.C_PLUS,
  "C": EnergeticCertificateLetter.C,
  "C_MINUS": EnergeticCertificateLetter.C_MINUS,
  "D_PLUS": EnergeticCertificateLetter.D_PLUS,
  "D": EnergeticCertificateLetter.D,
  "D_MINUS": EnergeticCertificateLetter.D_MINUS,
  "E_PLUS": EnergeticCertificateLetter.E_PLUS,
  "E": EnergeticCertificateLetter.E,
  "E_MINUS": EnergeticCertificateLetter.E_MINUS,
  "F_PLUS": EnergeticCertificateLetter.F_PLUS,
  "F": EnergeticCertificateLetter.F,
  "F_MINUS": EnergeticCertificateLetter.F_MINUS,
  "G_PLUS": EnergeticCertificateLetter.G_PLUS,
  "G": EnergeticCertificateLetter.G,
  "G_MINUS": EnergeticCertificateLetter.G_MINUS,
  "ISENTO": EnergeticCertificateLetter.ISENTO
};
export function EnergeticCertificate({
  value
}: {
  value: string;
}) {
  // Convert API format to display format
  const cert = API_TO_DISPLAY_MAP[value?.toUpperCase()] || EnergeticCertificateLetter.G;
  const isNotIsent = cert !== EnergeticCertificateLetter.ISENTO;
  const COLOR_HEX: Record<EnergeticCertificateLetter, string> = {
    [EnergeticCertificateLetter.A_PLUS]: "#16a34a",
    // green-600 (darker)
    [EnergeticCertificateLetter.A]: "#22c55e",
    // green-500
    [EnergeticCertificateLetter.A_MINUS]: "#4ade80",
    // green-400 (lighter)
    [EnergeticCertificateLetter.B_PLUS]: "#84cc16",
    // lime-500 (darker)
    [EnergeticCertificateLetter.B]: "#a3e635",
    // lime-400
    [EnergeticCertificateLetter.B_MINUS]: "#bef264",
    // lime-300 (lighter)
    [EnergeticCertificateLetter.C_PLUS]: "#eab308",
    // yellow-500 (darker)
    [EnergeticCertificateLetter.C]: "#fde047",
    // yellow-300
    [EnergeticCertificateLetter.C_MINUS]: "#fef08a",
    // yellow-200 (lighter)
    [EnergeticCertificateLetter.D_PLUS]: "#f97316",
    // orange-500 (darker)
    [EnergeticCertificateLetter.D]: "#fb923c",
    // orange-400
    [EnergeticCertificateLetter.D_MINUS]: "#fdba74",
    // orange-300 (lighter)
    [EnergeticCertificateLetter.E_PLUS]: "#dc2626",
    // red-600 (darker)
    [EnergeticCertificateLetter.E]: "#ea580c",
    // orange-600
    [EnergeticCertificateLetter.E_MINUS]: "#f87171",
    // red-400 (lighter)
    [EnergeticCertificateLetter.F_PLUS]: "#dc2626",
    // red-600 (darker)
    [EnergeticCertificateLetter.F]: "#ef4444",
    // red-500
    [EnergeticCertificateLetter.F_MINUS]: "#f87171",
    // red-400 (lighter)
    [EnergeticCertificateLetter.G_PLUS]: "#18181b",
    // zinc-800 (darker)
    [EnergeticCertificateLetter.G]: "#27272a",
    // zinc-700
    [EnergeticCertificateLetter.G_MINUS]: "#3f3f46",
    // zinc-600 (lighter)
    [EnergeticCertificateLetter.ISENTO]: "#9ca3af" // gray-400
  };
  return <span className="text-lg font-semibold" style={{
    color: isNotIsent ? COLOR_HEX[cert] : undefined
  }} data-sentry-component="EnergeticCertificate" data-sentry-source-file="EnergeticCertificate.tsx">
      {cert}
    </span>;
}